import React, { useState } from "react";
import CardModal from "./BookingConfirmModal";
import { Link, useLocation } from "react-router-dom";
import {
  UploadKyc,
  DocsSubmit,
  SpaModal,
  SpaForBooking,
  MultiProgressBar,
  BookingComplete,
} from "components";

function SelectPayment(props) {
  const [modalShow, setModalShow] = useState(false);
  const [page, setPage] = useState(null);
  const [spaModalShow, setSpaModalShow] = useState(false);
  const [kyc, setKyc] = useState(false);
  const [docs, setdocs] = useState(false);
  const [bookNow, setBookNow] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState("bank");
  const { pathname: location } = useLocation();

  const nextPage = (page) => {
    setPage(page);
  };

  const nextPageNumber = (pageNumber) => {
    switch (pageNumber) {
      case "1":
        setPage("pageone");
        break;
      case "2":
        setPage("pagetwo");
        break;
      case "3":
        setPage("pagethree");
        break;
      case "4":
        setPage("pagefour");
      default:
        setPage("1");
    }
  };
  console.log(page);
  const handleClick = () => {
    setPage("pageone");
    setKyc(!kyc);
  };
  console.log(bookNow);

  return (
    <div className="main__content pt-5">
      <div className="main__content-dashboard">
        <div className="withdraw-funds">
          <div className="withdraw-funds__inner">
            <h5>Select Your Payment Option</h5>
            <p>Use the form below to withdraw from wallet instantly</p>
            {/* <form > */}
            <div className="regi__type mb-5">
              <label for="methodSelect">Payment Method : </label>
              <select
                className="type__select"
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                id="methodSelect"
              >
                <option value="web3">Web3 (Crypto)</option>
                <option value="bank">Bank</option>
              </select>
            </div>

            {paymentMethod === "bank" ? (
              <div className="regi__type mb-5">
                <label for="bankSelect">Select Your Bank : </label>
                <select className="type__select" id="bankSelect">
                  <option value="maybank">Maybank</option>
                  <option value="cimb">CIMB</option>
                  <option value="affin">Affin Bank</option>
                </select>
              </div>
            ) : null}
            {kyc ? (
              <MultiProgressBar
                page={page}
                onPageNumberClick={nextPageNumber}
                onButtonClick={nextPage}
                formComplete={bookNow}
              />
            ) : null}

            {
              {
                pageone: <UploadKyc onButtonClick={nextPage} />,
                pagetwo: <DocsSubmit onButtonClick={nextPage} />,
                pagethree: (
                  <SpaForBooking
                    onEnable={() => setBookNow(!bookNow)}
                    onButtonClick={nextPage}
                    bookNow={bookNow}
                  />
                ),
                pagefour: <BookingComplete onButtonClick={nextPage} />,
              }[page]
            }

            {kyc ? null : docs ? null : location ===
                "/buy-prop-details/select-payment" ||
              location === "/rent-prop-details/select-payment" ? (
              <div className="text-center mt-3">
                {/* <Link
                  to="#"
                  className="w-100"
                  onClick={() => setSpaModalShow(true)}
                > */}
                <button
                  // type="submit"
                  className="button button--effect w-100 "
                  onClick={() => setSpaModalShow(true)}
                >
                  SPA Agreement
                </button>
                {/* </Link> */}
              </div>
            ) : (
              <div className="account-content">
                <div class="avatar-wrapper">
                  <label for="heroUpload" onClick={handleClick}>
                    KYC and Financing
                  </label>
                </div>
              </div>
            )}

            {
              location === "/buy-prop-details/select-payment" ? (
                <button
                  type="submit"
                  className={`button button--effect ${
                    bookNow ? "disable-btn" : ""
                  }`}
                  onClick={() => setModalShow(true)}
                  disabled={bookNow}
                >
                  Buy Now
                </button>
              ) : location === "/rent-prop-details/select-payment" ? (
                <button
                  type="submit"
                  className={`button button--effect ${
                    bookNow ? "disable-btn" : ""
                  }`}
                  onClick={() => setModalShow(true)}
                  disabled={bookNow}
                >
                  Rent Now
                </button>
              ) : null

              //     (
              //   <button
              //     type="submit"
              //     className={`button button--effect ${
              //       bookNow ? "disable-btn" : ""
              //     }`}
              //     onClick={() => setModalShow(true)}
              //     disabled={bookNow}
              //   >
              //     Book Now
              //   </button>
              // )
            }

            {/* </form> */}
          </div>
        </div>
        <CardModal
          show={modalShow}
          onHide={() => setModalShow(!modalShow)}
          title="Booking Confirmation"
          handleActiveTab={props.handleActiveTab}
        />
        <SpaModal
          show={spaModalShow}
          onEnable={() => setBookNow(false)}
          onHide={() => setSpaModalShow(false)}
        />
      </div>
    </div>
  );
}

export default SelectPayment;
